import { API } from 'aws-amplify';

// @ts-ignore
export const create = (one) => API.put('ihrespezialistenBackend', '/events', { body: one });

// @ts-ignore
export const read = () => API.get('ihrespezialistenBackend', '/events', {});

// @ts-ignore
export const readOne = (id) => API.get('ihrespezialistenBackend', `/events/${id}`, {});

// @ts-ignore
export const update = (id, one) => API.post('ihrespezialistenBackend', `/events/${id}`, { body: one });

// @ts-ignore
export const remove = (id) => API.del('ihrespezialistenBackend', `/events/${id}`, {});
